import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const CopyrightAnnouncementDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  // 直接跳转到公示链接并返回上一页
  useEffect(() => {
    // 这里可以直接根据id构建跳转链接，或者从其他地方获取noticeUrl
    // 由于我们没有直接的方式获取noticeUrl，这里我们可以假设所有公示都有默认的链接格式
    // 或者根据id直接跳转到一个默认的链接
    const noticeUrl = `https://whbqgw.yjygx.com/regPub/search`; // 默认的版权查询链接
    window.open(noticeUrl, '_blank', 'noopener noreferrer');
    
    // 延迟返回上一页，确保新标签页能够正常打开
    setTimeout(() => {
      navigate(-1);
    }, 500);
  }, [id, navigate]);

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="text-center py-16">
        <p className="text-gray-600">{t('common.loading', '加载中...')}</p>
      </div>
    </div>
  );
};

export default CopyrightAnnouncementDetailPage;